<section *ngIf="!isLoading">
	<div class="particular-session-title">
		<h1 class="zk-pb-1 zk-text-1">
			{{ 'MY_ACCOUNT.PLAN_SESSION.FORM.PARTICULAR_SESSION.TITLE' | translate }}
		</h1>

		<span class="zk-text-3">
			{{
				'MY_ACCOUNT.PLAN_SESSION.FORM.PARTICULAR_SESSION.DESCRIPTION'
					| translate
			}}
		</span>
	</div>

	<div class="private-session zk-mb-5">
		<p class="headline">
			{{
				'MY_ACCOUNT.PLAN_SESSION.FORM.PRICE_PER_SESSION.TITLE'
					| translate: { value: 50 }
			}}
		</p>
		<div
			freud-tooltip
			[tooltipLabel]="
				canUpdateOneHour
					? translateIt(
							'MY_ACCOUNT.PLAN_SESSION.FORM.PRICE_PER_SESSION.TOOLTIP_EDIT'
					  )
					: translateIt(
							'MY_ACCOUNT.PLAN_SESSION.FORM.PRICE_PER_SESSION.TOOLTIP_CANT_EDIT'
					  )
			"
		>
			<zk-currency-input
				[value]="data.priceOneHour"
				[variant]="canUpdateOneHour ? 'enabled-focus' : 'disabled'"
				[buttonVariant]="canUpdateOneHour ? 'enabled' : 'disabled'"
				(change)="onChangeForm('priceOneHour', $event)"
				(clickButton)="openModal('UPDATE_50_MIN_PRICE')"
				class="zk-w-full"
				[disableInput]="true"
			></zk-currency-input>
		</div>
	</div>

	<!-- Column 2 -->
	<div
		id="corporate-sessions"
		*ngIf="corporateTiers.length > 0"
		class="zk-w-full zk-mt-2"
	>
		<div class="zk-mb-6 particular-session-title">
			<h1 class="zk-text-1 zk-pb-1">
				{{
					'MY_ACCOUNT.PLAN_SESSION.FORM.CORPORATE_SESSIONS.TITLE' | translate
				}}
			</h1>
			<span class="zk-text-3">
				{{
					'MY_ACCOUNT.PLAN_SESSION.FORM.CORPORATE_SESSIONS.INFO.START'
						| translate
				}}
				<a
					target="_blank"
					rel="noopener"
					href="{{
						'MY_ACCOUNT.PLAN_SESSION.FORM.CORPORATE_SESSIONS.INFO.URL'
							| translate
					}}"
				>
					{{
						'MY_ACCOUNT.PLAN_SESSION.FORM.CORPORATE_SESSIONS.INFO.END'
							| translate
					}}
				</a>
			</span>
		</div>

		<div class="zk-pb-4">
			<h2 class="zk-text-1 zk-pb-1">
				{{
					'MY_ACCOUNT.PLAN_SESSION.FORM.CORPORATE_SESSIONS.DURATION_INFO.TITLE'
						| translate
				}}
			</h2>
			<span class="zk-text-3">
				{{
					'MY_ACCOUNT.PLAN_SESSION.FORM.CORPORATE_SESSIONS.DURATION_INFO.SUBTITLE'
						| translate
				}}
			</span>
		</div>

		<div class="zk-flex zk-flex-col zk-items-center">
			<div
				*ngFor="let tier of tiers; let i = index"
				class="
					tier
					zk-flex zk-flex-row zk-items-center zk-mb-4 zk-w-full zk-flex-wrap
				"
			>
				<div class="zk-flex zk-flex-row zk-w-full">
					<div
						class="
							tier-header
							zk-flex
							zk-flex-row
							zk-items-center
							zk-justify-start
							zk-pl-4
							zk-w-full
						"
					>
						<div
							freud-tooltip
							[tooltipLabel]="isPremium ? '' : this.getTierTooltipMessage()"
						>
							<input
								zkCheckbox
								[zkDisabled]="!isPremium"
								[attr.disabled]="!isPremium ? true : null"
								[zkHasError]="false"
								type="checkbox"
								[checked]="tierIsSelected(tier.id) && isPremium"
								(change)="toggleTier(tier.id)"
							/>
						</div>
						<h3
							class="zk-ml-2 zk-text-2 title-tier-card"
							[ngClass]="{
								'zk-text-2': tierIsSelected(tier.id) && isPremium,
								'zk-text-3': !tierIsSelected(tier.id) || !isPremium
							}"
						>
							{{
								'MY_ACCOUNT.PLAN_SESSION.FORM.TIER.CHECKBOX_LABEL'
									| translate: { value: tier.name }
							}}
						</h3>
					</div>

					<div
						class="
							tier-header
							zk-flex
							zk-flex-row
							zk-items-center
							zk-justify-end
							zk-pr-4
							zk-w-full
						"
						*ngIf="tier.elegible.full > 0"
					>
						<p
							class="zk-text-xs description-tier-card"
							[ngClass]="{
								'zk-text-2': tierIsSelected(tier.id) && isPremium,
								'zk-text-3': !tierIsSelected(tier.id) || !isPremium
							}"
						>
							{{
								'MY_ACCOUNT.PLAN_SESSION.FORM.TIER.DESCRIPTION'
									| translate
										: { clients: tier.elegible.full.toLocaleString('pt-BR') }
							}}
						</p>
						<div
							freud-tooltip
							[width]="300"
							tooltipLabel="{{
								'MY_ACCOUNT.PLAN_SESSION.FORM.TIER.TOOLTIP'
									| translate: { value: tier.compensation.full }
							}}"
						>
							<img
								src="/assets/icons/menu/info.svg"
								class="zk-ml-1"
								alt="info"
							/>
						</div>
					</div>
				</div>

				<div
					*ngIf="hasContactForTier(tier.id)"
					class="
						tier-footer
						zk-items-center
						zk-justify-start
						zk-px-5
						zk-py-2
						zk-flex
						zk-flex-row
						zk-w-full
					"
				>
					<span
						class="
							freud-icon freud-icon-xs freud-icon-calendar-event
							calendar-icon
							zk-mr-2
						"
					></span>
					<span class="tier-disclaimer">
						{{ 'MY_ACCOUNT.PLAN_SESSION.FORM.TIER.DISCLAIMER' | translate }}
					</span>
				</div>

				<div
					class="
						halfHourInfo
						zk-items-center
						zk-justify-start
						zk-flex
						zk-flex-row
						zk-w-full
						zk-mt-1
						zk-mb-2
						zk-mx-2
					"
					*ngIf="
						tier.acceptsHalfHour &&
						data.canAcceptTags.includes(tier.id) &&
						isPremium
					"
				>
					<p
						class="zk-text-xs description-tier-card"
						[ngClass]="{
							'zk-text-2': tierIsSelected(tier.id) && isPremium,
							'zk-text-3': !tierIsSelected(tier.id) || !isPremium
						}"
					>
						{{
							'MY_ACCOUNT.PLAN_SESSION.FORM.TIER.PLUS_DESCRIPTION'
								| translate
									: {
											halfTimeValue: tier.compensation.half,
											clients:
												tier.elegible.half === 0
													? tier.elegible.full.toLocaleString('pt-BR')
													: tier.elegible.half.toLocaleString('pt-BR')
									  }
						}}
					</p>
				</div>
			</div>
		</div>

		<div class="zk-pb-6" *ngIf="selectedTierThatAcceptsHalfHour && isPremium">
			<label class="zk-flex zk-items-center">
				<input
					zkCheckbox
					[zkDisabled]="!isPremium"
					[attr.disabled]="!isPremium ? true : null"
					[zkHasError]="false"
					type="checkbox"
					[checked]="data.acceptsHalfHour && isPremium"
					(change)="onChangeForm('acceptsHalfHour', !data.acceptsHalfHour)"
				/>
				<p
					class="zk-ml-2 zk-mt-1"
					[ngClass]="{
						'zk-text-2': isPremium,
						'zk-text-3': !isPremium
					}"
				>
					{{
						'MY_ACCOUNT.PLAN_SESSION.FORM.ACCEPT_HALF_HOUR_SESSIONS.LABEL'
							| translate
					}}
				</p>
			</label>

			<div
				class="zk-mt-6 zk-w-fit-content"
				*ngIf="data.acceptsHalfHour && isPremium && !isProfessionalZen"
			>
				<div class="zk-mb-6 zk-flex zk-items-center">
					<p class="zk-text-2">
						{{
							'MY_ACCOUNT.PLAN_SESSION.FORM.ACCEPT_HALF_HOUR_SESSIONS.PRICE_SESSION'
								| translate: { value: 30 }
						}}
					</p>
					<div
						freud-tooltip
						tooltipLabel="{{
							'MY_ACCOUNT.PLAN_SESSION.FORM.ACCEPT_HALF_HOUR_SESSIONS.TOOLTIP'
								| translate
						}}"
					>
						<img src="/assets/icons/menu/info.svg" class="zk-ml-1" alt="info" />
					</div>
				</div>
				<zk-currency-input
					[value]="data.priceHalfHour"
					[variant]="
						canUpdateHalfHour && isPremium ? 'enabled-focus' : 'disabled'
					"
					[disableInput]="true"
					[buttonVariant]="canUpdateHalfHour ? 'enabled' : 'disabled'"
					(change)="onChangeForm('priceHalfHour', $event)"
					(clickButton)="openModal('UPDATE_30_MIN_PRICE')"
				>
				</zk-currency-input>
			</div>
		</div>

		<div class="zk-flex zk-justify-end">
			<freud-button
				[loading]="isSaving"
				[disabled]="!this.formChanged"
				(click)="saveForm()"
			>
				{{ 'MY_ACCOUNT.PLAN_SESSION.FORM.SUBMIT_BUTTON' | translate }}
			</freud-button>
		</div>
	</div>
</section>

<section *ngIf="isLoading" class="zk-flex zk-justify-center zk-py-5">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</section>

<zk-dialog [(isOpen)]="isOpenModal" [clickOverlayCloses]="false">
	<ng-container zk-dialog-header>
		<h1
			*ngIf="
				modalStep === 'UPDATE_50_MIN_PRICE' ||
				modalStep === 'UPDATE_30_MIN_PRICE'
			"
			class="zk-text-white-base"
		>
			{{
				'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.HEADER'
					| translate
			}}
		</h1>

		<h1
			*ngIf="
				modalStep === 'CONFIRM_50_MIN_PRICE' ||
				modalStep === 'CONFIRM_30_MIN_PRICE'
			"
			class="zk-text-white-base"
		>
			{{
				'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.HEADER'
					| translate
			}}
		</h1>
	</ng-container>

	<ng-container zk-dialog-body>
		<div class="dialog-content">
			<div
				class="update"
				*ngIf="
					modalStep === 'UPDATE_50_MIN_PRICE' ||
					modalStep === 'UPDATE_30_MIN_PRICE'
				"
			>
				<h1>
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.TITLE'
							| translate
					}}
				</h1>
				<h2>
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.SUBTITLE'
							| translate
					}}
				</h2>

				<ul class="zk-mb-7 zk-pl-6">
					<li>
						{{
							'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.ITEM_1'
								| translate
						}}
					</li>
					<li *ngIf="modalStep === 'UPDATE_50_MIN_PRICE'">
						{{
							'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.ITEM_2'
								| translate
						}}
					</li>
				</ul>

				<h2 class="zk-pb-1">
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.FIELD_LABEL'
							| translate
					}}
				</h2>

				<zk-currency-input
					[value]="getModalPrice()"
					variant="enabled-focus"
					buttonVariant="hidden"
					(change)="setModalPrice($event)"
					[status]="modalError ? 'error' : 'default'"
					[message]="modalError"
				>
				</zk-currency-input>
			</div>

			<div
				class="zk-flex zk-flex-col zk-items-center zk-text-center"
				*ngIf="
					modalStep === 'CONFIRM_50_MIN_PRICE' ||
					modalStep === 'CONFIRM_30_MIN_PRICE'
				"
			>
				<p class="zk-pb-4">
					{{
						'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.TITLE'
							| translate
								: {
										value: modalStep === 'CONFIRM_50_MIN_PRICE' ? 50 : 30
								  }
					}}
				</p>

				<zk-currency-input
					[value]="getModalPrice()"
					variant="readonly"
					buttonVariant="hidden"
					(change)="setModalPrice($event)"
				></zk-currency-input>
			</div>
		</div>
	</ng-container>

	<ng-container zk-dialog-footer>
		<ng-container
			*ngIf="
				modalStep === 'UPDATE_50_MIN_PRICE' ||
				modalStep === 'UPDATE_30_MIN_PRICE'
			"
		>
			<button
				zk-button
				zkButtonColor="secondary"
				zkButtonSize="medium"
				(click)="leftButtonModal()"
				class="zk-mr-4"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.BUTTONS.CANCEL'
						| translate
				}}
			</button>
			<button
				zk-button
				zkButtonColor="primary"
				zkButtonSize="medium"
				(click)="rightButtonModal()"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.BUTTONS.SAVE'
						| translate
				}}
			</button>
		</ng-container>

		<ng-container
			*ngIf="
				modalStep === 'CONFIRM_50_MIN_PRICE' ||
				modalStep === 'CONFIRM_30_MIN_PRICE'
			"
		>
			<button
				zk-button
				zkButtonColor="secondary"
				zkButtonSize="medium"
				(click)="leftButtonModal()"
				class="zk-mr-4"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.BUTTONS.BACK'
						| translate
				}}
			</button>
			<button
				zk-button
				zkButtonColor="primary"
				zkButtonSize="medium"
				(click)="rightButtonModal()"
				[zkButtonLoading]="isSavingModal"
				style="width: 160px"
			>
				{{
					'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.BUTTONS.CONFIRM'
						| translate
				}}
			</button>
		</ng-container>
	</ng-container>
</zk-dialog>
